import { createFileRoute } from "@tanstack/react-router";
import Bipolar1Vs2DifferencePage from "@/pages/articles/Bipolar1Vs2DifferencePage";
export const Route = createFileRoute(
  "/what-is-the-difference-between-bipolar-1-and-bipolar-2",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Bipolar 1 vs 2 Differences | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Understand the key differences between Bipolar 1 and Bipolar 2 disorder—mania vs hypomania, depressive burden, diagnostic criteria, and treatment approaches.",
        },
        {
          property: "og:title",
          content: "Bipolar 1 vs 2 Differences | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Understand the key differences between Bipolar 1 and Bipolar 2 disorder—mania vs hypomania, depressive burden, diagnostic criteria, and treatment approaches.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/what-is-the-difference-between-bipolar-1-and-bipolar-2",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-the-difference-between-bipolar-1-and-bipolar-2",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <Bipolar1Vs2DifferencePage />;
}
